import { render } from "./MenuTemplate.vue?vue&type=template&id=31753826"
import script from "./MenuTemplate.vue?vue&type=script&lang=js"
export * from "./MenuTemplate.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__